import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Dialog, DialogActions, DialogBody, DialogTitle } from '../../catalyst/dialog';
import { Button } from '../../catalyst/button';
import type { UserListItem } from '@avisoma/shared';
import backend from '../../services/backend';

export function DeleteUserDialog({
  user,
  open,
  onClose,
}: {
  user: UserListItem | null;
  open: boolean;
  onClose: () => void;
}) {
  const queryClient = useQueryClient();

  const del = useMutation({
    mutationFn: () => backend.deleteUser(user!.id).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      onClose();
    },
  });

  if (!user) return null;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete {user.username}?</DialogTitle>
      <DialogBody>
        <p className="text-sm text-zinc-700 dark:text-zinc-300">
          This permanently deletes the user. If they have audit-log entries or uploads, the request will be
          blocked and you&apos;ll see a message explaining what&apos;s referencing them.
        </p>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Cancel
        </Button>
        <Button color="red" onClick={() => del.mutate()} disabled={del.isPending}>
          {del.isPending ? 'Deleting…' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
